import { Entity } from '../entity';
import { ComplianceDefinition } from './compliance.definition';

export enum IndividualComplianceRuleApplyTo {
    Everyone = 'Everyone',
    UserTypes = 'User Types',
    ResourceGroups = 'Resource Groups',
    UserLabels = 'User Labels'
}

export interface IndividualComplianceRule {
    _id: string;
    active?: boolean;
    definition: ComplianceDefinition;
    blockAssignment?: boolean;
    gracePeriodDays?: number;
    applyToRestrictions?: Entity[];
    applyTo?: IndividualComplianceRuleApplyTo;
}


export interface IndividualComplianceRuleGroup {
    category: string;
    count: number;
    complianceRules: IndividualComplianceRule[];
}

export interface ComplianceDefinitionTiny {
    category: string;
    count: number;
}
